<template>
  <v-row
    v-if="$store.getters.cartDetails"
    no-gutters
    align="start"
    justify="center"
    class="test_blue fill-height"
  >
    <v-card
      class="w-full overview-card elevation-2 pa-6 pt-4 d-flex flex-column justify-space-between"
    >
      <!-- Top Section -->
      <div class="overview-content">
        <h2 class="overview-title mb-8">Overview</h2>
        <v-divider
          style="border-width: 2px; border-color: #000"
          class="mb-10"
        />

        <!-- Subtotal -->
        <div class="d-flex justify-space-between mb-8">
          <span class="label-text" v-text="$t('checkout.subtotal')" />
          <span
            class="value-text"
            v-text="
              $appFormatters.formatMoney($store.getters.cartDetails.subTotal)
            "
          />
        </div>

        <div
          v-if="$store.getters.cartDetails.deliveryPrice !== 0"
          class="d-flex justify-space-between mb-8"
        >
          <span class="label-text" v-text="$t('general.delivery')" />
          <span
            class="value-text"
            v-text="
              $appFormatters.formatMoney(
                $store.getters.cartDetails.deliveryPrice
              )
            "
          />
        </div>

        <!-- Carrying bag -->
        <div
          v-if="
            $store.getters.storeInfo.configs.extraBagCost > 0 && !isTableOrder
          "
          class="d-flex justify-space-between mb-8"
        >
          <span
            class="label-text"
            v-text="$t('checkout.checkout_extra_bag_cost')"
          />
          <span
            class="value-text"
            v-text="
              $appFormatters.formatMoney(
                $store.getters.storeInfo.configs.extraBagCost
              )
            "
          />
        </div>

        <!-- Service Fee -->
        <div
          v-if="
            $store.getters.cartDetails.serviceFee > 0 &&
            $store.getters.cartDetails.serviceFee !== null
          "
          class="d-flex justify-space-between mb-10"
        >
          <span class="label-text" v-text="$t('checkout.serviceFee')" />
          <span
            class="value-text"
            v-text="
              $appFormatters.formatMoney($store.getters.cartDetails.serviceFee)
            "
          />
        </div>
        <!-- Discount -->
        <div
          v-if="discountAmount > 0"
          class="d-flex justify-space-between mb-10"
        >
          <span class="label-text" v-text="$t('offers.discount')" />
          <span
            class="value-text"
            v-text="'- ' + $appFormatters.formatMoney(discountAmount)"
          />
        </div>

        <!-- User credit -->
        <div
          v-if="credits > 0 && $store.getters.user && $store.getters.useCredit"
          class="d-flex justify-space-between mb-10"
        >
          <span class="label-text" v-text="$t('customerProfile.credits')" />
          <span
            class="value-text"
            v-text="'- ' + $appFormatters.formatMoney(credits)"
          />
        </div>

        <v-divider class="mb-8" />

        <!-- Total -->
        <div class="d-flex justify-space-between mb-12">
          <span class="total-label" v-text="$t('checkout.total')" />
          <span
            class="total-label"
            v-text="$appFormatters.formatMoney($store.getters.total)"
          />
        </div>
      </div>

      <!-- Bottom Section -->
      <div class="overview-bottom">
        <div
          class="discount-text mb-8"
          style="cursor: pointer"
          @click="handleClick"
        >
          <span class="clickable-title">{{
            $t("checkout.discountCodeText")
          }}</span>
        </div>

        <v-btn
          :loading="$store.getters.isLoading"
          :class="checkoutValid ? 'checkout-btn-active' : 'checkout-btn'"
          :disabled="!checkoutValid || $store.getters.isLoading"
          variant="flat"
          @click="checkout()"
          v-text="$t('checkout.checkout')"
        />

        <!-- Pickup date requirements info -->
        <v-alert
          v-if="shouldShowPickupDateAlert"
          type="info"
          dense
          outlined
          class="mt-4 pickup-date-alert"
        >
          <div>
            <div class="mb-2 pickup-date-title">
              {{ $t("checkout.pickup_date_requirements") }}
            </div>
            <div
              v-for="(product, index) in productsRequireSpecificDates"
              :key="index"
              class="mt-1"
              style="font-size: 0.85rem"
            >
              • {{ product.productName }}:
              {{ formatDate(product.productRequiredPickupDateFrom) }} -
              {{ formatDate(product.productRequiredPickupDateTo) }}
            </div>
          </div>
        </v-alert>
      </div>
    </v-card>
  </v-row>
</template>
<script>
export default {
  name: "CardCheckoutX",
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
    isTableOrder: {
      type: Boolean,
      required: false,
    },
  },
  data: () => ({
    panel: 0,
    discountAmount: 0,
    credits: 0,
    total: 0,
    errorMessage: "",
  }),
  computed: {
    checkoutValid: {
      get() {
        const self = this;
        let foundIndex = _.findKey(self.$store.getters.checkoutValidation, {
          status: false,
        });

        if (foundIndex) {
          self.errorMessage =
            self.$store.getters.checkoutValidation[foundIndex].message;
          console.log("foundIndex", foundIndex);
          return self.$store.getters.checkoutValidation[foundIndex].status;
        } else {
          return true;
        }
      },
      set(val) {
        return val;
      },
    },
    productsRequireSpecificDates: function () {
      const cartItems = this.$store.getters.cartDetails?.items || [];
      return cartItems.filter((item) => item.productRequiredPickupDateFrom);
    },
    shouldShowPickupDateAlert: function () {
      // Only show alert if there are products requiring specific dates
      if (this.productsRequireSpecificDates.length === 0) {
        return false;
      }

      // Show alert if validation is failing (invalid date or no date selected)
      const validationStatus =
        this.$store.getters.checkoutValidation?.deliveryWhen?.status;
      if (validationStatus === false) {
        return true;
      }

      // Show alert if ASAP is selected but products require specific dates
      if (this.$store.getters.deliveryIsAsap) {
        return true;
      }

      // Show alert if no date is selected yet but products require dates
      if (!this.$store.getters.deliveryDropoffDateTime) {
        return true;
      }

      // Hide alert if date is valid
      return false;
    },
  },
  watch: {
    "$store.getters.checkoutValidation.promoCode.status": function () {
      this.calculateAmounts();
    },
    "$store.getters.deliveryMethod": function () {
      this.calculateAmounts();
    },
    "$store.getters.deliveryPrice": function () {
      this.calculateAmounts();
    },
    "$store.getters.cartDetails": function () {
      this.calculateAmounts();
    },
  },
  beforeMount() {
    this.$store.dispatch("cart/setLoad");
  },
  methods: {
    handleClick() {
      const self = this;
      self.$emit("onClickDiscount", false);
    },
    checkout: async function () {
      console.log("sssssssssssss");
      const self = this;
      self.$emit("click", false);
    },
    calculateAmounts: function () {
      const self = this;
      self.discountAmount = self.$store.getters.cartDetails.offer;
      self.credits = self.$store.getters.cartDetails.credits;

      // const bagCost = this.isTableOrder
      //   ? "0.00"
      //   : self.$store.getters.storeInfo.configs.extraBagCost;

      let totalLocal = parseFloat(self.$store.getters.cartDetails.cartTotal);

      // if (
      //   self.$store.getters.deliveryMethod === "delivery-service" &&
      //   self.$store.getters.deliveryPrice
      // ) {
      //   totalLocal += parseFloat(self.$store.getters.deliveryPrice);
      // }
      this.$store.dispatch("checkout/setTotal", totalLocal);
    },
    formatDate: function (dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("da-DK", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=REM:wght@400;700&display=swap");

.overview-card {
  width: 100%;
  max-width: 475px;
  height: 659px;
  border-radius: 15px;
  font-family: "REM", sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
}

.overview-content {
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}

.overview-bottom {
  flex-shrink: 0;
}

.overview-title {
  font-family: "REM", sans-serif;
  font-weight: 700;
  font-size: 35px;
  line-height: 100%;
  letter-spacing: 0;
  color: black;
}

.label-text {
  font-family: "REM", sans-serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 100%;
  letter-spacing: 0;
}

.value-text {
  @extend .label-text;
  text-align: right;
}

.total-label {
  font-family: "REM", sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 100%;
  letter-spacing: 0;
  color: black;
}

.checkout-btn {
  text-transform: none;
  width: 100%;
  padding: 0 30px 0 30px !important;
  background-color: #d9d9d9 !important;
  border-radius: 5px;
  font-family: "REM", sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 100%;
  letter-spacing: 0;
  height: 75px !important;
  color: black;
  margin: 0 auto;
}
.checkout-btn-active {
  text-transform: none;
  width: 100%;
  padding: 0 30px 0 30px !important;
  background-color: #4caf50 !important;
  border-radius: 5px;
  font-family: "REM", sans-serif;
  font-weight: 700;
  font-size: 28px !important;
  line-height: 100%;
  letter-spacing: 0;
  height: 75px !important;
  color: white !important;
  margin: 0 auto;
}

.pickup-date-title {
  font-size: 1rem;
  font-weight: 600;
}

.pickup-date-alert {
  max-height: 200px;
  overflow-y: auto;
}
.discount-text {
  font-family: "REM", sans-serif;
  font-weight: 400;
  font-style: italic;
  font-size: 22px;
  line-height: 100%;
  letter-spacing: 0;
  color: #03436e;
}
@media (max-width: 768px) {
  .overview-card {
    width: 100%;
    height: auto;
    padding: 16px !important;
  }

  .overview-title {
    font-size: 28px;
  }

  .label-text,
  .value-text {
    font-size: 18px;
  }

  .total-label {
    font-size: 22px;
  }

  .discount-text {
    font-size: 18px;
  }

  .checkout-btn {
    font-size: 22px;
    height: 60px !important;
  }
}

@media (max-width: 480px) {
  .overview-title {
    font-size: 24px;
  }

  .label-text,
  .value-text {
    font-size: 16px;
  }

  .total-label {
    font-size: 20px;
  }

  .discount-text {
    font-size: 16px;
  }

  .checkout-btn {
    font-size: 20px;
    height: 55px !important;
    padding: 0 20px 0 20px !important;
  }
  .clickable-title {
    cursor: pointer !important;
  }
  .checkout-valid {
    background-color: green !important;
    color: white !important;
  }
}
</style>
